import {
  ITaxEstimate,
  ITaxEstimateBase
} from "@wingspanhq/bookkeeping/dist/lib/interfaces/taxEstimate";
import {
  IBalanceResponse,
  IWithholdingTransactionResponse
} from "@wingspanhq/bookkeeping/dist/lib/interfaces/withholdingTransaction";
import { IPendingWithholding } from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import { WSInfiniteQueryConfig, WSQueryConfig } from "@ws-react-query";
import bookkeepingService from "../../services/bookkeeping";
import { useWSInfiniteQuery, useWSQuery } from "../helpers";
import {
  QUERY_TAXES_TAX_ESTIMATE,
  QUERY_TAXES_WITHHOLDING_BALANCE,
  QUERY_TAXES_WITHHOLDING_TRANSACTIONS,
  QUERY_TAXES_PENDING_WITHHOLDING
} from "./keys";

export const useQueryTaxEstimate = (
  options: ITaxEstimateBase,
  queryConfig?: WSQueryConfig<ITaxEstimate, unknown>
) =>
  useWSQuery(
    [QUERY_TAXES_TAX_ESTIMATE, options],
    async () => await bookkeepingService.createTaxEstimate(options),
    {
      retry: false,
      ...queryConfig
    }
  );

export const useQueryWithholdingBalance = (
  queryConfig?: WSQueryConfig<IBalanceResponse, unknown>
) =>
  useWSQuery(
    QUERY_TAXES_WITHHOLDING_BALANCE,
    async () => await bookkeepingService.getWithholdingBalance(),
    { retry: false, ...queryConfig }
  );

export const useQueryWithholdingTransactions = (
  queryConfig?: WSInfiniteQueryConfig<
    IWithholdingTransactionResponse[],
    unknown
  >
) =>
  useWSInfiniteQuery(
    QUERY_TAXES_WITHHOLDING_TRANSACTIONS,
    async ({ pageParam = 1 }) => {
      return await bookkeepingService.getWithholdingTransactions({
        page: {
          size: 10,
          number: pageParam
        }
      });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < 10) {
          return undefined;
        }

        return allPages.length + 1;
      },
      ...queryConfig
    }
  );

export const useQueryPendingWithholdings = (
  queryConfig?: WSQueryConfig<IPendingWithholding[], unknown>
) =>
  useWSQuery(
    QUERY_TAXES_PENDING_WITHHOLDING,
    async () => await bookkeepingService.getPendingWithholdings(),
    { retry: false, ...queryConfig }
  );
